import React, { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import { Grid, GridColumn } from '@atlaskit/page';

import { FocusedPageHeader } from 'src/components/accessibility';
import prMessages from 'src/sections/repository/sections/pull-request-list/components/i18n';
import Breadcrumbs from 'src/sections/workspace/components/breadcrumbs';

import WorkspaceHelmet from '../../components/workspace-helmet';

import Filter from './containers/filter';
import PullRequestsPageTable from './containers/pull-requests-page-table';

const PullRequestRoute = () => {
  const { pageTitle } = prMessages;

  return (
    <Fragment>
      <WorkspaceHelmet pageTitle={pageTitle} />
      <Grid layout="fluid" spacing="comfortable">
        <GridColumn>
          <FocusedPageHeader breadcrumbs={<Breadcrumbs />}>
            <FormattedMessage {...pageTitle} />
          </FocusedPageHeader>
          <Filter />
          <PullRequestsPageTable />
        </GridColumn>
      </Grid>
    </Fragment>
  );
};

export default PullRequestRoute;
